import { Offer } from "../../model/Offer";
import { OfferRepository } from "../../repositories/Repository";

export class GetOfferUseCase {
    constructor(private offerRepository: OfferRepository) {}
  
    async execute(): Promise<Offer[]> {
      return await this.offerRepository.getOffer();
    }
  }